export const productSelectedOptionClassName = [
  'pl-s',
  'pr-[11px]',
  'border',
  'border-gray-100',
  'bg-base-white',
  '!text-gray-900',
  'border-[1px]',
  'rounded-[6px]',
  'h-[44px]',
  'px-2s',
  'py-2xs',
  'shadow-[0_1px_3px_0_rgba(26,32,34,0.10),_0_1px_2px_0_rgba(26,32,34,0.06)]'
].join(' ');

export const productContentClassName = [
  'z-20',
  'h-fit',
  'bg-white',
  'flex',
  'flex-col',
  'items-center',
  'w-full',
  'pb-[120px]'
].join(' ');

export const productListClassName = [
  'w-fit',
  'flex',
  'min-h-[calc(100%-84px)]',
  'relative',
  'justify-center',
  'flex-1',
  'text-base',
  'flex-col',
  'items-center',
  'h-full',
  'overflow-hidden',
  'ml-[calc((100%-1280px)/2)]',
  'py-10xl',
  'pb-9xl'
].join(' ');

export const productItemClassName = [
  'w-full',
  'grow-1',
  'shrink-0',
  'flex',
  'border',
  'border-gray-100',
  'rounded-[12px]',
  'flex-row',
  'p-3xs',
  'gap-4xs',
  'rounded-xl',
  'bg-gray-50',
  'text-gray-400',
  'font-semibold',
  'leading-xl',
  'items-center',
  'cursor-pointer'
].join(' ');

export const workloadContactUsClassName = [
  'w-full',
  'bg-cic-blue-500',
  'px-xl',
  'py-m',
  'text-base-white',
  'text-md',
  'font-semibold',
  'leading-sm'
].join(' ');

export const workloadOptionClassName = [
  'flex',
  'flex-row',
  'justify-start',
  'items-start',
  'gap-[8px]'
].join(' ');

export const comparionTableRowClassName = [
  'flex',
  'flex-row',
  'w-full',
  'bg-gray-50',
  'gap-0',
  'h-[64px]',
  'items-center',
  'text-sm',
  'font-semibold',
  'leading-lg',
  'text-primary'
].join(' ');
